module.exports = __webpack_public_path__ + "img/value1.c6cf714a.svg";